import { CircleAtenyaLogo, Logo } from 'assets'
import React from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

function Welcome() {
   const navigate = useNavigate()
   return (
      <div className="auth-section p-3 position-relative min-vh-100">
         <div className="logo-section">
            <img src={Logo} alt="logo" />
         </div>
         <div className="auth-wrap welcome-page">
            <div className="form-section-wrap welcome-section">
               <div className="form-section">
                  <div>
                     <img src={CircleAtenyaLogo} alt="CircleAtenyaLogo" />
                  </div>
                  <h1 className="at-text-dark add-channel">Welcome to Atenya!</h1>

                  <div className="mt-3 w-100">
                     <Button
                        className="at-auth-btn w-100"
                        onClick={() => {
                           navigate('/')
                        }}>
                        Explore your dashboard
                     </Button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default Welcome
